import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { string } from 'prop-types';

import { Row, Col } from '@ajaibid/components';
import { TradeSocket } from 'Component/Socket';
import { Table } from 'Component/Table';
import TableProvider from 'Component/Table/context';

import { useUserData } from '@services/users/me';
import { headerContents, getRunningTradeContents } from './helpers';

function RunningTradeSDP({ code }) {
  const { userData } = useUserData();
  const [tradeData, setTradeData] = useState([]);

  const tableContents = useMemo(() => getRunningTradeContents(tradeData), [tradeData]);

  useEffect(() => {
    setTradeData([]);
  }, [code, setTradeData]);

  const handleMessage = useCallback(
    (data) => {
      const parsedData = JSON.parse(data);
      if (parsedData.ticker !== code) {
        return;
      }
      const newTradeData = [parsedData, ...tradeData.slice(0, 19)];
      setTradeData(newTradeData);
    },
    [code, setTradeData, tradeData]
  );

  return (
    <>
      <Row noGutters>
        <Col>
          <TableProvider>
            <Table
              headerContents={headerContents}
              emptyText="Belum ada transaksi yang terjadi."
              source="runningTradeDetailPage"
              tableContents={tableContents}
            />
          </TableProvider>
        </Col>
      </Row>

      {userData?.id && <TradeSocket code={code} user={userData} onMessage={handleMessage} />}
    </>
  );
}

RunningTradeSDP.propTypes = {
  code: string,
};

RunningTradeSDP.defaultProps = {
  code: '',
};

export default RunningTradeSDP;
